import { Injectable } from '@angular/core';
import {AllEventsSetting} from '../models/all-events-setting';
import {Observable, Subject} from 'rxjs/Rx';
import {BackendService} from './backend.service';
import {SiteSetting} from '../models/site-setting';
import {GroupSetting} from '../models/group-setting';

@Injectable()
export class SiteService {

  data: SiteSetting[] = [];

  constructor(private http: BackendService) { }

  sites(): SiteSetting[] {
    return this.data;
  }

  getAllSite(reload = false): Observable<SiteSetting[]> {
    if (!reload && this.data.length) {
      return Observable.create(observe => {
        observe.next(this.data);
        observe.complete();
      });
    }
    return Observable.create((subscriber) => {
      this.http.get('/api/data/site/all-site').subscribe((res) => {
        const obj = Object.assign(new AllEventsSetting(), res);
        this.data = obj.data;
        subscriber.next(this.data);
        subscriber.complete();
      }, (error) => {
        subscriber.error(error);
      });
    });
  }

  addSite(site: SiteSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/site/create-site`, JSON.stringify(site))
        .subscribe((res) => {
          observe.next(res);
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  updateSite(site: SiteSetting): Observable<any> {
    return Observable.create(observe => {
      this.http.put(`/api/data/site/update-site`, JSON.stringify(site))
        .subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  deleteSite(siteId: number): Observable<any> {
    return Observable.create((observe) => {
      this.http.delete(`/api/data/site/delete-site/${siteId}`).subscribe((res) => {
        observe.next(res);
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/site.service.ts